import { FC, useCallback } from 'react';

import styles from './styles.module.scss';
import { Button } from '../../components/Button';
import { useTranslation } from '../../hooks/useTranslation';
import { useEditor } from '../../providers/EditorContext';
import { useNavigate } from 'react-router-dom';

import CheckIcon from '../../assets/images/check_icon.png';

export const CheckoutFinished: FC = () => {
    const translate = useTranslation();
    const { reset } = useEditor();
    const navigate = useNavigate();

    const createNew = useCallback(() => {
        reset();
        navigate('/');
    }, [reset, navigate]);

    return (
        <div className={styles.wrapper}>
            <div className="header">
                <h1>{translate('orderCompleted')}</h1>
                <h2>{translate('orderCompletedSubtitle')}</h2>
            </div>

            <div className={styles.content}>
                <img className={styles.icon} src={CheckIcon} alt="Order Completed" />
                <p>{translate('orderCompletedMessage')}</p>
            </div>

            <div className="footer">
                <div className="footer-content">
                    <Button text={translate('createNew')} onClick={createNew} />
                </div>
            </div>
        </div>
    );
};
